<template>
  <div class="ll-progress-card-list">
    <slot name="select-tool" />
    <div class="ll-progress-card-list__content">
      <LlProgressCard
        v-for="(item,itemIndex) in menuItems"
        :key="itemIndex"
        :title="item.title"
        :number="item.number"
        :type="item.type"
        :has-percent="item.hasPercent"
        :color="item.color"
        :icon="item.icon"
        @click="$_onClick(item)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlProgressCardList",
  props: {
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_onClick(item) {
      this.$emit("click", item.value);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-progress-card-list";
</style>